function Loading ({isFixed= true, isLayer = true, style}) {
    return (<>
            {
                isLayer && <div className="nl-layer --loading" aria-hidden="true"></div>
            }
            <div className={`nl-loading ${isFixed && '--fixed'}`} style={style} role="status" aria-busy="true">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </>
    )
}
export default Loading;
